export default __webpack_public_path__ + "static/media/ellipsis.9f2729df.svg";